import React, { createRef, useEffect, useState } from "react";
import { usePositionedScreenContext } from "../../PositionedScreen";

const TabNode = ({ node, className, style, resizeHandle, handlers, renderLayout }) => {
  const { elementRefs } = usePositionedScreenContext();

  if (elementRefs?.current && node?.id) {
    if (!elementRefs.current[node.id]) {
      elementRefs.current[node.id] = createRef();
    }
  }

  useEffect(() => {
    const el = elementRefs.current[node.id]?.current;
    if (el) {
      el.setAttribute("data-type", node.type);
    }
  }, [elementRefs, node.id, node.type]);

  return (
    <div
      key={node.id}
      ref={elementRefs.current[node.id]}
      title={node.type}
      className={`z-tab ${className}`}
      style={style}
      {...handlers}
    >
      {resizeHandle(node)}
      <TabView config={node} renderLayout={renderLayout} />
    </div>
  );
};

const TabView = ({ config, renderLayout }) => {
  const [selectedTabId, setSelectedTabId] = useState(config.tabs[0]?.id || null);

  const handleTabClick = (e, tabId) => {
    e.stopPropagation();
    setSelectedTabId(tabId);
  };

  const selectedTab = config.tabs.find((tab) => tab.id === selectedTabId);

  return (
    <>
      <div>
        <div>
          {config.tabs.map((tab) => (
            <div
              key={tab.id}
              className={`-z-renderer-tab ${
                tab.id === selectedTabId ? "-z-renderer-tab-active" : "-z-renderer-tab-inactive"
              }`}
              onClick={(e) => handleTabClick(e, tab.id)}
            >
              {tab.name}
            </div>
          ))}
        </div>
      </div>

      <>
        {selectedTab ? (
          <div style={{ height: `calc(100% - 36px)` }}>{renderLayout(selectedTab.children)}</div>
        ) : (
          <div>No content available</div>
        )}
      </>
    </>
  );
};

export default TabNode;
